import datagram_logo from './datagram_logo.png';
import flipit from './flipit.png';
import helix_logo from './helix_logo.png';
import magnetohr from './magnetohr.png';
import metaflora from './metaflora.png';
import safemoon from './safemoon.png';
import tiktrix from './tiktrix.png';
import unstoppable_domains_logo from './unstoppable_domains_logo.png';
import valley from './valley.png';

export const partners = {
  // datagram_logo: datagram_logo.src,
  helix_logo: helix_logo.src,
  unstoppable_domains_logo: unstoppable_domains_logo.src,
  valley: valley.src,
  flipit: flipit.src,
  tiktrix: tiktrix.src,
  metaflora: metaflora.src,
  magnetohr: magnetohr.src,
  safemoon: safemoon.src,
};
